import { dispatchEventBus } from "@catchoftheday/state";
export var TRIGGER_ONEPASS_FREE_SHIPPING_DRAWER_EVENT = {
  type: "@global/TRIGGER_ONEPASS_FREE_SHIPPING_DRAWER"
};
export var triggerOnePassFreeShippingDrawer = function triggerOnePassFreeShippingDrawer(payload) {
  dispatchEventBus({
    type: TRIGGER_ONEPASS_FREE_SHIPPING_DRAWER_EVENT.type,
    payload: payload
  });
};